export const ALLERGIES = [
  'Gluten',
  'Milk',
  'Eggs',
  'Fish',
  'Soy',
  'Shellfish',
  'Tree Nuts',
  'Peanuts',
  'Celery',
  'Mustard',
  'Sesame',
  'Sulphites',
  'Lupin',
  'Molluscs',
] as const;

export const DIETS = [
  'Vegetarian',
  'Vegan',
  'Pescatarian',
  'Kosher',
  'Gluten-Free',
  'Halal',
] as const;

export type Allergy = (typeof ALLERGIES)[number];
export type Diet = (typeof DIETS)[number];

// Convert enum display value to translation key
// e.g. "Tree Nuts" → "treeNuts", "Gluten-Free" → "glutenFree", "Milk" → "milk"
export const toTranslationKey = (value: string): string => {
  return value
    .replace(/-(\w)/g, (_, c) => c.toUpperCase())
    .replace(/\s+(\w)/g, (_, c) => c.toUpperCase())
    .replace(/^(\w)/, (_, c) => c.toLowerCase());
};
